import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";
import { ClipboardModule } from "ngx-clipboard";
import { map, startWith } from "rxjs";

import { ChangeDetectionStrategy, Component, computed, inject, output, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { RouterLink } from "@angular/router";

import { ENV } from "../../../app/app.runtime";
import { LANGUAGE_STORAGE_KEY } from "../../../app/constants";
import { AuthService } from "../../../services/authservice";
import { NWD_VERSION } from "../../../version";
import { ChooseCustomerDialog } from "../../dialogs/choose-customer-dialog/choose-customer-dialog";

@Component({
  selector: "profile-menu",
  imports: [TranslatePipe, AngularSvgIconModule, ClipboardModule, RouterLink, NgClickOutsideDirective],
  templateUrl: "./profile-menu.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./profile-menu.component.scss", "../navigation/navigation.scss"],
})
export class ProfileMenuComponent {
  private auth = inject(AuthService);
  private translate = inject(TranslateService);
  private dialog = inject(MatDialog);

  public openRolesDialog = output();
  public logout = output();

  protected isExpanded = signal(false);
  protected customerDisplayName = computed(() => this.auth.viewingCustomer().name);
  protected userDisplayName = computed(() => this.auth.currentUser().displayName);
  protected hasMultipleCustomers = computed(() => this.auth.customers().length > 1);
  protected readonly languages = this.translate.getLangs();
  protected readonly currentLanguage = toSignal(
    this.translate.onLangChange.pipe(
      map((e) => e.lang),
      startWith(this.translate.getCurrentLang()),
    ),
    { requireSync: true },
  );
  protected readonly isProduction = ENV.NWD_API_BASE_URL.includes("api.automation.surf.net");
  protected readonly nwdReleaseVersion = NWD_VERSION;

  protected toggleExpandedState(): void {
    this.isExpanded.update((previous) => !previous);
  }

  protected closeMenu(): void {
    this.isExpanded.update(() => false);
  }

  protected openChooserDialog() {
    this.dialog.open(ChooseCustomerDialog, {});
  }

  protected emitOpenRolesDialog() {
    this.openRolesDialog.emit();
  }

  protected emitLogout() {
    this.logout.emit();
  }

  protected switchLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  }
}
